/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Unlock_SubtitleInputs */

const en_home_unlock_subtitle = /** @type {(inputs: Home_Unlock_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activating takes a few minutes and opens up everything included with your policy.`)
};

const fr_home_unlock_subtitle = /** @type {(inputs: Home_Unlock_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'activation prend quelques minutes et ouvre tout ce qui est inclus dans votre police.`)
};

/**
* | output |
* | --- |
* | "Activating takes a few minutes and opens up everything included with your policy." |
*
* @param {Home_Unlock_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_unlock_subtitle = /** @type {((inputs?: Home_Unlock_SubtitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Unlock_SubtitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_unlock_subtitle(inputs)
	return fr_home_unlock_subtitle(inputs)
});